import React from 'react'
import './loader.css'

function Loader() {
  /* First letter of the app name as the monogram */
  const initial = (process.env.REACT_APP_APP_NAME || 'J')[0]

  return (
    <div className="site-loader">

      {/* Concentric rings + monogram */}
      <div className="sl-mark">
        <div className="sl-ring sl-ring--1" />
        <div className="sl-ring sl-ring--2" />
        <div className="sl-ring sl-ring--disc" />
        <span className="sl-mark__letter">{initial}</span>
      </div>

      {/* Bank name + tagline */}
      <div className="sl-text">
        <span className="sl-text__name">{process.env.REACT_APP_APP_NAME}</span>
        <span className="sl-text__sub">Secure Banking</span>
      </div>

      {/* Bouncing dots */}
      <div className="sl-dots">
        <span className="sl-dot" />
        <span className="sl-dot" />
        <span className="sl-dot" />
        <span className="sl-dot" />
        <span className="sl-dot" />
      </div>

    </div>
  )
}

export default Loader